import { ClassName, ElementId, HeadingTags } from '@type/component-data-types'
import React from 'react'

type Props = {
  tagName: HeadingTags
  children?: React.ReactNode
  id?: ElementId
  className?: ClassName
}

const Heading = React.memo((props: Props) => {
  const { id, tagName, children } = props
  const Tag = props.tagName || 'div'
  const cssClass = props.className ? `${tagName} ${props.className}` : tagName

  return (
    <Tag id={id} className={cssClass}>
      {children}
    </Tag>
  )
})

export default Heading
